import React, { createContext, ReactNode, useEffect, useState } from "react";
import { matchPath, useLocation } from "react-router-dom";

const routes: { [key: string]: { type: string; value: string } } = {
    "/sign-in": { type: "/sign-in", value: "sign-in" },
    "/sign-in/otp-check": { type: "/sign-in/otp-check", value: "otp-check" },
    "/sign-in/email-check": { type: "/sign-in/email-check", value: "email-check" },
    "/": { type: "/", value: "homepage" },
    "/explore": { type: "/explore", value: "explore" },
    "/meal-plan/ai": { type: "/meal-plan/ai", value: "meal-plan-ai" },
    "/meal-plan": { type: "/meal-plan", value: "meal-plan" },
    "/account": { type: "/account", value: "account" },
    "/meal-plan/add-meal": { type: "/meal-plan/add-meal", value: "add-meal" },
    "/mobile-login/:deviceId": { type: "/mobile-login/:deviceId", value: "device-registration" },
    "/user-create-recipe": { type: "/user-create-recipe", value: "create-recipe" },
    "/filter": { type: "/filter", value: "filter-recipes" },
    "/favorites": { type: "/favorites", value: "favorites" },
    "/cooking-history": { type: "/cooking-history", value: "cooking-history" },
    "/grocery-list": { type: "/grocery-list", value: "grocery-list" },
    "/account/rate-upliance": { type: "/account/rate-upliance", value: "rate-upliance" },
    "/account/view-rate-upliance": { type: "/account/view-rate-upliance", value: "view-rate-upliance" },
    "/cooking-history/edit/:sessionId": { type: "/cooking-history/edit/:sessionId", value: "edit-cooking-history" },
    "/recipe/:recipeId": { type: "/recipe/:recipeId", value: "recipe-page" },
    "/recipe/:recipeId/reviews": { type: "/recipe/:recipeId/reviews", value: "recipe-reviews" },
    "/recipe/:recipeId/steps": { type: "/recipe/:recipeId/steps", value: "recipe-steps" },
}

const getLocation = (pathname: string) => {
    if (routes[pathname]) {
        return routes[pathname].value;
    }
    let matchedValue = "";
    Object.entries(routes).forEach(([key, value]) => {
        if (matchPath(pathname, { path: key, exact: true, strict: false })) {
            matchedValue = value.value ?? "";
        }
    });

    return matchedValue;
};

export const LocationContext = createContext({ location: '' });

const LocationProvider = ({ children }: { children: ReactNode }) => {
    const [location, setLocation] = useState('')
    const routeLocation = useLocation();
    useEffect(() => {
        const approute = getLocation(routeLocation.pathname)
        setLocation(approute)
    }, [routeLocation])

    return (
        <LocationContext.Provider value={{ location }}>
            {children}
        </LocationContext.Provider>
    )
}

export default LocationProvider;
